import React from 'react';
import { SxProps, alpha } from '@mui/system';
import { StyledButton } from '../styled/styledButton';
import { useTheme } from '../../hooks/useTheme';
import {
  PLAY_BUTTON_BOX_SHADOW_INNER_OPACITY,
  PLAY_BUTTON_BOX_SHADOW_OUTER_OPACITY,
  PLAY_BUTTON_SIZE,
  PLAY_BUTTON_SIZE_UNIT,
} from './const';

export interface PlayButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  sx?: SxProps;
  size?: number;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const PlayButton: React.FC<PlayButtonProps> = ({ sx, size = PLAY_BUTTON_SIZE, children, disabled, ...restProps }) => {
  const theme = useTheme();
  return (
    <StyledButton
      role="button"
      tabIndex={0}
      {...restProps}
      sx={{
        width: `${size}${PLAY_BUTTON_SIZE_UNIT}`,
        height: `${size}${PLAY_BUTTON_SIZE_UNIT}`,
        borderRadius: '50%',
        border: `2px solid ${theme.palette.white}`,
        backgroundColor: theme.palette['brand pink'],
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: `0px 2px 8px ${alpha(theme.palette.black, PLAY_BUTTON_BOX_SHADOW_OUTER_OPACITY)}`,
        transition: theme.transitions.create(['background-color', 'transform', 'box-shadow'], {
          duration: theme.transitions.duration.short,
        }),
        ...(!disabled && {
          '&:hover': {
            transformOrigin: 'center center',
            transform: 'scale(1.09)',
            backgroundColor: theme.palette['brand pink hover'],
          },
          '&:active': {
            boxShadow: `inset 1px 2px 4px ${alpha(theme.palette.black, PLAY_BUTTON_BOX_SHADOW_INNER_OPACITY)}`,
          },
        }),
        '& > *': {
          color: 'white',
        },
        ...sx,
      }}
    >
      {children}
    </StyledButton>
  );
};
